import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import './styles.css';

const CompanyLogo = props => {
  const { name = 'Company Name', logo, link, styles } = props;

  const logoImage = logo
    ? {
        backgroundImage: `url(${logo})`,
        backgroundColor: 'transparent',
      }
    : null;

  const logoStyles =
    logo || styles
      ? {
          ...logoImage,
          ...styles,
        }
      : null;

  return link ? (
    <NavLink
      to={link}
      className="company-logo company-logo--link"
      style={{ ...logoStyles }}
    >
      {!logo && <h2 className="company-logo__text">{name}</h2>}
    </NavLink>
  ) : (
    <span className="company-logo" style={{ ...logoStyles }}>
      {!logo && <h2 className="company-logo__text">{name}</h2>}
    </span>
  );
};

CompanyLogo.propTypes = {
  name: PropTypes.string,
  logo: PropTypes.string,
  link: PropTypes.string,
  styles: PropTypes.object,
};

export default CompanyLogo;
